'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavSectionHeader", {
    enumerable: true,
    get: function() {
        return NavSectionHeader;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useNavSectionHeader = require("./useNavSectionHeader");
const _renderNavSectionHeader = require("./renderNavSectionHeader");
const _useNavSectionHeaderStylesstyles = require("./useNavSectionHeaderStyles.styles");
const NavSectionHeader = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useNavSectionHeader.useNavSectionHeader_unstable)(props, ref);
    (0, _useNavSectionHeaderStylesstyles.useNavSectionHeaderStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useNavSectionHeaderStyles_unstable')(state);
    return (0, _renderNavSectionHeader.renderNavSectionHeader_unstable)(state);
});
NavSectionHeader.displayName = 'NavSectionHeader';
